import { FetchContext } from '../fetch-context';
import { AwardSummary } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardSummaries: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<AwardSummary[]> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/award-summaries`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardSummary[]>(fetchContext.errorStore, response, 'get award summaries'));
